module.exports = __webpack_public_path__ + "img/u2186.a32fdebd.png";